<template>
  <div v-if="shopInfo" class="header-title-wrap-bc">
    <div class="l-container shop-info-wrap">
      <div class="shop-offer-title">
        <div class="logo-container">
          <a :href="shopInfo.site" target="_blank" class="shop-link">
            <img v-if="shopInfo.logo" :src="shopInfo.logo" alt="" />
          </a>
          <div :class="['title-container', { 'with-logo': shopInfo.logo }]">
            <h1>
              <a :href="shopInfo.site" target="_blank" class="shop-link">
                {{ shopInfo.name }}
              </a>
            </h1>
            <ShopRating
              :shop="{ shop_info: shopInfo }"
              :labels="['оценки', 'оценок', 'оценок']"
              align="right"
              is-shop
              is-modal
            />
          </div>
        </div>
        <div class="socials-container">
          <SocialMediaShare
            :title="shopInfo.name"
            :description="shopInfo.site"
            :image="shopInfo.logo || undefined"
            theme="black"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { FullShopInfo } from '~/interfaces/api';

const ShopRating = defineAsyncComponent(
  () => import('~/components/ui/shop-rating/ShopRating.vue')
);
defineProps({
  shopInfo: {
    type: Object as () => FullShopInfo,
    required: true,
  },
});
</script>

<style lang="scss" scoped>
.header-title-wrap-bc {
  background-color: #ffffff;
  margin: 8px 0;
  padding: 0;
  @include md-block {
    margin: 12px 0;
  }
  @include lg-block {
    margin: 20px 0;
  }

  .shop-info-wrap {
    display: flex;
    align-items: center;

    .shop-offer-title {
      width: 100%;
      display: flex;
      border-radius: 8px;
      background-color: #ffffff;
      box-shadow: 0 0 16px 0 rgba(85, 91, 143, 0.12);
      padding: 12px;
      gap: 20px;
      @include md-block {
        padding: 20px;
      }
      @include lg-block {
        padding: 28px;
        border-radius: 12px;
      }

      .title-container {
        h1 {
          display: block;
          font-family: 'Inter', sans-serif;
          font-size: 20px;
          font-style: normal;
          font-weight: 800;
          line-height: 24px;
          text-transform: uppercase;
          margin-bottom: 12px;
          @include md-block {
            font-size: 32px;
            line-height: 32px;
          }
          @include xl-block {
            font-size: 48px;
            line-height: 48px;
          }
        }

        &.with-logo {
          @include md-block {
            padding-right: 200px;
          }
          @include lg-block {
            padding-right: 300px;
          }
        }
      }

      .logo-container {
        flex-grow: 1;
        position: relative;

        img {
          height: 24px;
          margin-bottom: 12px;
          @include md-block {
            position: absolute;
            right: 0;
            top: 0;
            height: 40px;
          }
          @include xl-block {
            height: 52px;
          }
        }
      }

      .socials-container {
        display: flex;
        flex-direction: row;
        align-items: baseline;
        flex-wrap: nowrap;
        gap: 20px;
        @include md-block {
          flex-direction: column;
          gap: 24px;
          justify-content: flex-start;
        }

        .shop-offer-favorite {
          width: 20px;
          height: 20px;
        }

        :deep(img) {
          margin: 0;
        }
      }
    }
  }

  .shop-link,
  .shop-link img {
    text-decoration: none;
    border: none;
    color: $achromatic-black;
    user-select: none;
    outline: none;
    object-fit: contain;
    object-position: top;
    @include md-block {
      max-width: 200px;
    }
    @include lg-block {
      max-width: initial;
    }
  }
}

:deep(.social-share) {
  display: inline-flex;
}
</style>
